import React, {useState} from 'react';
import {TopMenu} from './';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import AdbIcon from '@mui/icons-material/Adb';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';

import { styled, useTheme } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';
import { useNavigate } from 'react-router-dom';



const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
  })(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  }));

const Navbar = ({openLeftMenu, setOpenLeftMenu}) => {
    const navigate = useNavigate();

    const handleClick = () => {
        return null
    }

    const handleClickLogo = () => {
        navigate('/');
    }


    return (
        <>
            <AppBar position="fixed" open={openLeftMenu}>
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        <IconButton
                            aria-label="open drawer"
                            onClick={handleClick}
                            edge="start"
                            style={{color:'white'}}
                            sx={{
                                marginRight: 2,
                                ...(openLeftMenu && { display: 'none' }),
                              }}
                        >
                            <MenuIcon />
                        </IconButton>

                        <AdbIcon sx={{mr:1, display: { xs:!openLeftMenu ? '' : 'none', md:openLeftMenu ? 'none' : 'flex' } }} />
                        <Typography
                            variant="h6"
                            noWrap
                            component="a"
                            href="#"
                            onClick={handleClickLogo}
                            sx={{
                                mr: 2,
                                display: { xs:!openLeftMenu ? '' : 'none', md:openLeftMenu ? 'none' : 'flex' },
                                fontFamily: 'monospace',
                                fontWeight: 700,
                                letterSpacing: '.3rem',
                                color: 'inherit',
                                textDecoration: 'none'
                            }}
                        >
                            DLuna Music
                        </Typography>
                        <TopMenu />
                    </Toolbar>
                </Container>
            </AppBar>
        </>
    )
}

export default Navbar;
